// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1iD2e","additionalInfo":"AgreementModal_additionalInfo__2v13p"};